import React, { useState, useEffect } from 'react';
import { S3Client } from 'aws_js';
import { Biscuit } from '../../../utils';
import Rbac from '../../../utils/Rbac';
import { getApiHost } from '../../../Sync';

import {s3Actions, fileManagerSelectors, fileManagerActions, alertsActions, useSelector} from 'inbooma-api';
import t from '../../helpers/t';
import EditableInput from '../../helpers/EditableInput';

import FileManagerSidebar from './FileManagerSidebar';
import FileManagerSortTabs from './FileManagerSortTabs';
import FolderOrFileItem from './FileManagerFolderFileItem';
import FolderOrFileDetailView from './FileManagerFolderFileDetail';

export const rbac = new Rbac({
        _rbac : {
            "admin" : {
                write : true,
                editFolder : true,
                editDocument : true,
                editTags : true,
            },
            "manager" : {
                write : false,
                editFolder : false,
                editDocument : false,
                editTags : true,
            },
            "booking-manager" : {
                write : false,
                editFolder : false,
                editDocument : false,
                editTags : true,
            },
            "manager-location" : {
                write : false,
                editFolder : false,
                editDocument : false,
                editTags : true,
            },
            "user" : {
                write : false,
                editFolder : false,
                editDocument : false,
                editTags : false,
            },
            "garage-staff" : {
                write : false,
                editFolder : false,
                editDocument : false,
                editTags : false,
            }
        }
    });

let selectedEntityCopy = null;
let _id = 0; // For internal - "temporary" - document items
let dragCount = 0; // Avoids flickering of page when dragging in items

export const FileManagerPage = props => {

    const [activeFolder, setActiveFolder] = useState(null);
    const [previousFolder, setPreviousFolder] = useState(null);
    const [selectedEntity, setSelectedEntity] = useState(null);
    const [draggedFilesCount, setDraggedFilesCount] = useState(0);
    const [addFolderEditMode, setAddFolderEditMode] = useState(false);
    const [tagFilter, setTagFilter] = useState(null);
    const _addDocument = useSelector(state => state.s3_data.addDocumentS3);
    const [temporaryId,setTemporaryId] = useState(_id);
    const [documentPending, setDocumentPending] = useState(false);


    // @todo:
    //const [sortKey, setSortKey] = useState('name');
    //const [sortDirection, setSortDirection] = useState('desc');

    const dropRef = React.createRef();
    
    const onClickOpenFolder = (ev) => {

        const id = ev.currentTarget.getAttribute('data-entity-id');

        const callback = (response) => {
            if (response.success) {
                setActiveFolder(Number(id));
                const activeFolderEntity = fileManagerSelectors.getFolderById(props.folders, Number(id));
                setPreviousFolder(activeFolderEntity.parent_id);
            } else {
                props.dispatch(alertsActions.addAlert({
                    message : t('error_folder_access_forbidden'),
                    icon : 'fi fi-x',
                }));
            }
        }

        if (id !== null) {
            props.dispatch(fileManagerActions.getFolder({ 
                /*filter: {
                    parent_id: id
                },*/
                id,
                callback,
                token: Biscuit.get('token')
            }));

            setActiveFolder(Number(id));
            const activeFolderEntity = fileManagerSelectors.getFolderById(props.folders, Number(id));
            setPreviousFolder(activeFolderEntity.parent_id);
        } else {
            setActiveFolder(null);
            setPreviousFolder(null);
        }

        setTagFilter(null);
        setSelectedEntity(null);
        setAddFolderEditMode(false);
    }

    const onAddFolderSubmit = name => {

            if (name !== '' && name !== null) {

                props.dispatch(fileManagerActions.addFolder({
                    body: {
                        name,
                        client_id: Number(Biscuit.get('user.client_id')),
                        parent_id: activeFolder,
                        all_roles: true
                    }, 
                    token: Biscuit.get('token') 
                }));

                props.dispatch(alertsActions.addAlert({
                    message : t('added_${a}',{a:t('folder')}),
                    icon : 'fi fi-folder-add',
                }));

            }

            setAddFolderEditMode(false);
    }

    useEffect(() => {
        if(_addDocument.success === '' || !documentPending){
            return;
        }
        if(_addDocument.success === true){
            // Anim 2: Posting
            props.dispatch(fileManagerActions.editDocument({
                body: {
                    id: temporaryId,
                    uploadStatus: 'posting',
                    folders: [{ id : activeFolder }],
                }
            }));

            props.dispatch(fileManagerActions.addDocument({
                body: {
                    file : _addDocument.data.Name, //uploadedFile.key, //uploadedFile.Location,
                    description: _addDocument.data.Name,
                    type: 'UserDoc',
                    lang: Biscuit.get('user.lang'),
                    client_id: Number(Biscuit.get('user.client_id')),
                    folders: [{ id : activeFolder }],
                },
                token: Biscuit.get('token')
            }));

            props.dispatch(alertsActions.addAlert({
                message : t('added_${a}',{a:t('document')}),
                icon : 'fi fi-page-add',
            }));

            // Anim 3: Done
            setTimeout(() => {
                props.dispatch(fileManagerActions.editDocument({
                    id: temporaryId,
                    body: {
                        id: temporaryId,
                        uploadStatus: 'finished',
                        folders: [{ id : activeFolder }],
                    }
                }));
            }, 800);

            setTimeout(() => {
                props.dispatch(fileManagerActions.deleteDocument({
                    id: temporaryId,
                    body: {
                        uploadStatus: 'finished',
                        folders: [{ id : activeFolder }],
                    }
                }));
            }, 1600);
        } else {
            console.log('CATCH S3 UPLOAD', _addDocument.data);
            alert('S3 Upload failed: ' + _addDocument.data);

            props.dispatch(fileManagerActions.deleteDocument({
                body: {
                    id: temporaryId,
                    uploadStatus: 'finished',
                    folders: [{ id : activeFolder }],
                }
            }));
        }
        setDocumentPending(false);
    },[_addDocument])

    const uploadFile = file => {

        const temp_id = 'temporary_' + _id++;
        setTemporaryId(temp_id);

        // Anim I: Uploading
        props.dispatch(fileManagerActions.addDocument({
            body: {
                id: temp_id,
                name: file.name,
                file: file.name,
                uploadStatus: 'uploading',
                description : '',
                created : file.lastModified,
                folders: [{ id : activeFolder }],
            }
        }));
       props.dispatch(s3Actions.addDocumentS3({
            file: file,
            doctype: 'UserDoc',
            client_id: Biscuit.get('user.client_id'),
            apiEntryPoint:getApiHost(),
            token: Biscuit.get('token')
        }));
            setDocumentPending(true);
    }

    const onUploadFile = (e) => {
        const files = e.target.files;

        for (let i = 0; i < files.length; i++) {
            uploadFile(files[i]);
        }
    }

    const handleDragIn = (e) => {
        e.preventDefault();
        e.stopPropagation();
        dragCount++;

        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
          setDraggedFilesCount(e.dataTransfer.items.length);
        }
    }
    const handleDragOut = (e) => {
        e.preventDefault();
        e.stopPropagation();
        dragCount--;

        if (dragCount > 0) return;
        setDraggedFilesCount(0);
    }

    const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
    }

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDraggedFilesCount(0);

        if (e.dataTransfer.items && e.dataTransfer.items.length > 0
         && e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            // e.dataTransfer.files would be empty if dropped content type is non-file-like

            for (let i = 0; i < e.dataTransfer.items.length; i++) {
                uploadFile(e.dataTransfer.items[i].getAsFile());
            }

            e.dataTransfer.clearData(); // Causes warning (sometimes)
            dragCount = 0;
        }
    }

    useEffect(() => {

        const div = dropRef.current;

        div.addEventListener('dragenter', handleDragIn);
        div.addEventListener('dragleave', handleDragOut);
        div.addEventListener('dragover', handleDrag);
        div.addEventListener('drop', handleDrop);        

        return () => {
            div.removeEventListener('dragenter', handleDragIn);
            div.removeEventListener('dragleave', handleDragOut);
            div.removeEventListener('dragover', handleDrag);
            div.removeEventListener('drop', handleDrop);
        }
    });

    useEffect(() => {

        if (selectedEntity === null || (selectedEntityCopy !== null && selectedEntityCopy.id === selectedEntity.id)) {
            // Problem: As of now, selectedEntity is not an ID (like activeFolder), but an object
            // -> react would not notice update of that entity when detailView is already open
            // Solution: Call setSelectedEntity in callback below to update DetailView
            // @todo Make selectedEntity numeric
            return;
        }

        // = setSelectedEntity callback
        if (selectedEntity !== null && typeof selectedEntity.lang !== 'undefined') {
            // GET full file entity (needed within FolderFileDetailView)

            setSelectedEntity(null);

            selectedEntityCopy = { ...selectedEntity };

            props.dispatch(fileManagerActions.getDocument({
                id: selectedEntity.id,
                token: Biscuit.get('token'),
                callback: (response) => {
                    if (response.success) {
                        setSelectedEntity(response.data);
                        setTimeout(() => { selectedEntityCopy = null }, 1000);
                    }
                }
            }));

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[selectedEntity]);

    return (
        <>
            <FileManagerSidebar
                folders={props.folders.filter(folder => folder.parent_id === null)}
                tags={props.tags}
                foldersFetchSuccess={props.foldersFetchSuccess}
                activeFolder={activeFolder}
                onClickFolder={onClickOpenFolder}
                dispatch={props.dispatch}
                setTagFilter={setTagFilter}
                setAddFolderEditMode={setAddFolderEditMode}
                setActiveFolder={setActiveFolder}
                setSelectedEntity={setSelectedEntity}
            />

            <div
                id="inb-c-main"
                className="columns filemanager-main"
                ref={dropRef}
                style={{width:'78%', float:'right'}}>
                
                <FileManagerSortTabs />

                <div className="filemanager-main-content">

                    {!props.foldersFetchSuccess
                     ?
                        <div className="inb-c-loader">
                            <div className="inb-c-loader--item">
                            <div className="inb-c-loader--bg row">
                                <div className="loader-mask r-1 medium-offset-1 medium-1 column"></div>
                                <div className="loader-mask r-1 medium-offset-4 medium-1 column"></div>
                                <div className="loader-mask r-1 medium-offset-7 medium-1 column"></div>
                                <div className="loader-mask r-1 medium-offset-10 medium-1"></div>
                                <div className="loader-mask vert-ph-1"></div>
                                <div className="loader-mask r-2 medium-offset-1 medium-1 column"></div>
                                <div className="loader-mask r-2 medium-offset-4 medium-8 column"></div>
                                <div className="loader-mask r-2 medium-offset-7 medium-1 column"></div>
                                <div className="loader-mask r-2 medium-offset-10 medium-1"></div>
                                <div className="loader-mask vert-ph-2"></div> 
                            </div>
                            </div>
                        </div>
                    :
                    <>
                    {props.folders.length === 0 &&
                        <div
                            id="inb-app-access-error"
                            className="inb-announcement">
                            <div className="inb-image-box">
                                <img src="assets/img/upload.svg" />
                            </div>
                            <h3>{t('filemanager_msg_no_folders')}</h3>
                            <p>{t('filemanager_msg_no_folders_body')}</p>
                       </div>
                    }

                    {draggedFilesCount > 0 && activeFolder !== null && rbac.hasPermission('write') &&
                        <div className="upload-area">
                            <div className="upload-cloud">
                                {t('upload_${a}_files_here',{a:draggedFilesCount})}
                            </div>
                        </div>
                    }

                    {activeFolder !== null &&
                        <a 
                            href="#"
                            className="inb-c-item-details-row row"
                            style={{paddingLeft:'1rem'}}
                            data-entity-id={previousFolder}
                            onClick={onClickOpenFolder}>
                            &#8629; {t('navigate_up')}
                        </a>
                    }

                    {tagFilter !== null 
                        ? <>
                        {/* Docs (filtered) */}
                        <aside className="filemanager-main-filterbar small-12 column clearfix">
                            <p style={{float:'left'}}>
                                {t('docs_with_tag')}
                                <strong>{tagFilter}</strong>
                            </p>
                            <button
                                type="button"
                                className="button hollow secondary float-right button-abort round"
                                title={t('reset_filter')}
                                onClick={() => setTagFilter(null) }> 
                                <i className="fi fi-x"></i>
                            </button>
                        </aside>
                        {props.docs.map(file => (
                            <FolderOrFileItem
                                key={file.id}
                                file={file}
                                dispatch={props.dispatch}
                                onClickEditEntity={file_id => { setSelectedEntity(fileManagerSelectors.getFileById(props.docs, file_id)) }}
                        />
                        ))}
                        </>
                        : <>
                        {/* Uploading - temporary - files */}
                        {activeFolder !== null
                        && fileManagerSelectors.getFolderById(props.folders, activeFolder)
                            .user_docs
                            .filter(doc => typeof doc.uploadStatus !== 'undefined')
                            .map(file => (
                            <FolderOrFileItem
                                key={file.id}
                                file={file}
                                dispatch={props.dispatch}
                                onClickEditEntity={file_id => { setSelectedEntity(fileManagerSelectors.getFileFromFolderById(props.folders, activeFolder, file_id)) }}
                            />
                        ))}

                        {/* Folders */}
                        {props.folders.filter(folder => folder.parent_id === activeFolder)
                                    .map(folder => (
                            <FolderOrFileItem
                                folder={folder}
                                key={folder.id}
                                dispatch={props.dispatch}
                                onClickEditEntity={folder_id => { setSelectedEntity(fileManagerSelectors.getFolderById(props.folders, folder_id)) }}
                                onClickOpenFolder={onClickOpenFolder}
                            />
                        ))}

                        {/* All regular - non temporary - files */}
                        {activeFolder !== null
                        && fileManagerSelectors.getFolderById(props.folders, activeFolder)
                            .user_docs
                            .filter(doc => typeof doc.uploadStatus === 'undefined')
                            .map(file => (
                            <FolderOrFileItem
                                key={file.id}
                                dispatch={props.dispatch}
                                file={file}
                                onClickEditEntity={file_id => { setSelectedEntity(fileManagerSelectors.getFileFromFolderById(props.folders, activeFolder, file_id)) }}
                            />
                        ))}
                        
                        {rbac.hasPermission('write') && props.foldersFetchSuccess && activeFolder === null &&
                        <div className="inb-c-item-details-row row add-folder-row">
                            <div className="entity-title small-12 medium-4 column">
                                {!addFolderEditMode ?
                                <div onClick={() => setAddFolderEditMode(true)}>
                                    <i className="fi fi-folder-add entity-icon"></i> 
                                    + {t('add_${a}',{a:t('folder')})}
                                </div>
                                :
                                <EditableInput
                                    value=""
                                    placeholder={t('new_folder_name')}
                                    inputType="input"
                                    onSubmit={onAddFolderSubmit}
                                    onClose={() => setAddFolderEditMode(false)}
                                />
                                }
                            </div>
                        </div>
                        }

                        {rbac.hasPermission('write') 
                        && props.foldersFetchSuccess 
                        && activeFolder !== null &&
                        <div className="inb-c-item-details-row row add-folder-row" style={{paddingTop:'4px'}}>
                            <div className="entity-title small-12 medium-3 column">
                                <label
                                htmlFor="upload-file-input"
                                style={{fontSize:'.85rem',fontWeight:'normal'}}>
                                    <a>
                                    {/* Left the href="#" out by purpose: fileInput wouldn't get called */}
                                        <i className="fi fi-page-add entity-icon"></i> 
                                        + {t('add_${a}',{a:t('document')})}
                                    </a>
                                </label>
                                <input
                                id="upload-file-input"
                                name="upload-file-input"
                                type="file"
                                style={{position: 'fixed', top: '-100em'}}
                                onChange={onUploadFile}
                                />         
                                {/*
                                onClick={(event)=> { 
                                    event.target.value = null
                                }}
                                */}                  
                            </div>
                        </div>
                    }
                    </>}

                    </>}

                 </div>
            </div>

            {selectedEntity !== null &&
                <FolderOrFileDetailView
                 // @todo Or could store & dispatcher be inherited automatically
                    entity={selectedEntity}
                    dispatch={props.dispatch}
                    tags={props.tags}
                    folders={props.folders}
                    locations={props.locations}
                    setTagFilter={setTagFilter}
                    onClose={() => { setSelectedEntity(null) }}
                />
            }
        </>
    );
};